import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { OrderFrequencySlice, OrderFrequencyValue } from './order-frequency-types'
import { FREQUENCY } from '@classy/campaign-page-blocks'

const DEFAULT_FREQUENCY: OrderFrequencyValue = 'one-time'

export const makeOrderFrequencyInitialState = (
  config: Config,
  urlParams: URLParams,
): OrderFrequencySlice => {
  let value = urlParams.frequency

  // If there is an frequency in the URL params, use that immediately
  if (value) {
    return { value }
  }

  // If Intelligent Asks is enabled, use the Intelligent Ask frequency
  if (config.intelligentAsks?.isEnabled) {
    const intelligentAskFrequency = config.intelligentAskAmounts?.isDefaultRecurring
      ? FREQUENCY.MONTHLY
      : FREQUENCY.ONE_TIME

    return { value: intelligentAskFrequency }
  }

  // If there is no frequency in the URL params and I. Asksis not enabled, use the default frequency
  if (!value) {
    config.frequency.options.forEach((option) => {
      if (option.isDefault) {
        value = option.name
      }
    })
  }

  return { value: value || DEFAULT_FREQUENCY }
}
